var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6666 12.1333C10.6357 12.1333 9.79995 12.9691 9.79995 14V46.6667C9.79995 47.6976 10.6357 48.5333 11.6666 48.5333H44.3333C45.3642 48.5333 46.1999 47.6976 46.1999 46.6667V14C46.1999 12.9691 45.3642 12.1333 44.3333 12.1333H11.6666ZM5.94995 14C5.94995 9.87627 7.54289 8.28333 11.6666 8.28333H44.3333C48.457 8.28333 50.0499 9.87627 50.0499 14V46.6667C50.0499 50.7904 48.457 52.3833 44.3333 52.3833H11.6666C7.54289 52.3833 5.94995 50.7904 5.94995 46.6667V14Z",
    fill: "#2D6772"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.625 3.5C39.0747 3.5 40.25 4.52835 40.25 5.79688V13.4531C40.25 14.7217 39.0747 15.75 37.625 15.75C36.1753 15.75 35 14.7217 35 13.4531V5.79688C35 4.52835 36.1753 3.5 37.625 3.5Z",
    fill: "#2D6772"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.375 3.5C19.8247 3.5 21 4.52835 21 5.79688V13.4531C21 14.7217 19.8247 15.75 18.375 15.75C16.9253 15.75 15.75 14.7217 15.75 13.4531V5.79688C15.75 4.52835 16.9253 3.5 18.375 3.5Z",
    fill: "#2D6772"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 22.75C7 21.7835 8.10612 21 9.47059 21H46.5294C47.8939 21 49 21.7835 49 22.75C49 23.7165 47.8939 24.5 46.5294 24.5H9.47059C8.10612 24.5 7 23.7165 7 22.75Z",
    fill: "#2D6772"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.6e616571f51f8c6a6e37b14e72370a9a.svg";
export { ForwardRef as ReactComponent };